import React, { useEffect, useState } from 'react';
import '../style/home.css';
import { useNavigate, useLocation } from 'react-router-dom';
import Select from 'react-select';
import { MdCurrencyPound } from "react-icons/md";
import { applicantArray, loanTypes } from '../constants/form_constatnts';
import api, { setApiInterceptors } from '../utils/api';
import Swal from 'sweetalert2';
import { PhoneNumberInput } from '../component/Common';
import { isValidPhoneNumber } from 'react-phone-number-input';

function Home() {
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const { state } = useLocation();

  const [mortgage, setMortgage] = useState({
    loanType: '',
    applicantCount: '',
    loanAmount: '',
    phoneNumbers: []
  });

  useEffect(() => {

    setIsInitialLoad(false);
  }, []);

  useEffect(() => {
    if (state?.message) {
      Swal.fire({
        text: state.message,
        icon: 'success',
        showConfirmButton: false,
      })
    }
  }, [state, navigate]);

  useEffect(() => { }, [isInitialLoad]);

  const fetchRequirements = async () => {
    try {
      const result = await api.get('/get-initial-requirement');
      const data = result.data.requirementData;
      if (data) {
        setMortgage({
          loanType: loanTypes.find(option => option.value === data.loanType) || '',
          applicantCount: applicantArray.find(option => option.value === `${data.applicantCount}`) || '',
          loanAmount: data.amount || '',
        });
      } else {
        navigate('/mortgage_form/0')
      }
    } catch (error) {
    }
  };

  const handleSelectChange = (value, name) => {
    setMortgage((prevData) => ({ ...prevData, [name]: value }));
    setErrors((prevData) => ({ ...prevData, [name]: "" }));
  };

  // Format loan amount with commas
  const formatLoanAmount = (value) => {
    let input = value.replace(/\D/g, '');
    const formattedNumber = input.replace(/\B(?=(\d{2})+(?!\d))/g, ",");
    return formattedNumber;
  }

  // Handle change for text inputs
  const handleInputChange = (e) => {
    const { id, value } = e.target;
    let formattedValue = value;

    if (id === 'loanAmount') {
      formattedValue = formatLoanAmount(value);
    }

    setMortgage((prevData) => ({ ...prevData, [id]: formattedValue }));
    setErrors((prevData) => {
      const newErrors = { ...prevData };
      delete newErrors[id];
      return newErrors;
    });
  };

  // Handle form submission
  const handleFormSubmission = async () => {
    let isValid = true;
    const newErrors = {};
    let firstErrorFieldId = null;

    const setFieldError = (field, fieldName, errorMsg) => {
      if (!field) {
        isValid = false;
        newErrors[fieldName] = errorMsg;
        if (!firstErrorFieldId) firstErrorFieldId = fieldName;
      }
    };

    setFieldError(mortgage.loanType, "loanType", "Loan Type is required.");
    setFieldError(mortgage.loanAmount, "loanAmount", "Loan Amount is required.");
    setFieldError(mortgage.applicantCount, "applicantCount", "Applicant Count is required.");

    const phoneNumbers = [];
    if (mortgage.applicantCount?.value > 0) {
      for (let i = 0; i < parseInt(mortgage.applicantCount.value); i++) {
        const phoneFieldName = `mobilePhone${i + 1}`;
        const phoneValue = mortgage[phoneFieldName];

        if (!phoneValue) {
          isValid = false;
          newErrors[phoneFieldName] = `Mobile number for Applicant ${i + 1} is required.`;
          if (!firstErrorFieldId) firstErrorFieldId = phoneFieldName;
        } else if (!isValidPhoneNumber(phoneValue)) {
          isValid = false;
          newErrors[phoneFieldName] = `Enter a valid mobile number for Applicant ${i + 1}.`;
          if (!firstErrorFieldId) firstErrorFieldId = phoneFieldName;
        } else {
          phoneNumbers.push(phoneValue);
        }
      }
    }

    setErrors(newErrors);

    if (isValid) {
      try {
        let amount = mortgage.loanAmount.replace(/,/g, '');
        const result = await api.post('/initial-requirement', {
          loanType: mortgage.loanType.value,
          applicantCount: mortgage.applicantCount.value,
          amount: amount,
          phoneNumbers,
        })
        if (result.status == 200) {
          const formId = result.data.formId;
          navigate(`/mortgage_form/0?applicationId=${formId}`);
        } else if (result.status == 201) {
          Swal.fire({
            text: result.data.message,
            icon: 'error',
            showConfirmButton: false,
          })
        }
      } catch (error) {
        console.error("Error submitting form:", error);

      }
    }
  };

  const handlePhoneNumber = (value, name) => {
    setMortgage((prevData) => ({ ...prevData, [name]: value }));
    setErrors((prevData) => ({ ...prevData, [name]: "" }));
  }

  const customSelectStyles = (fieldName) => ({
    control: (provided) => ({
      ...provided,
      borderColor: errors[fieldName] ? 'red' : provided.borderColor,
      '&:hover': {
        borderColor: errors[fieldName] ? 'red' : provided['&:hover'].borderColor,
      },
    }),
  });

  return (
    <div className="home_container">
      <main className="main-content">
        <div className='loan_form'>
          <div className="form_name">Mortgage Loan Application Form
            <p>All fields are required to submit the application
              <span className="required">*</span>
            </p>
          </div>
          <div className='select_loan_type'>
            <div className='name_div'>
              <h2>Select Loan Type</h2>
            </div>
            <div className='data_div'>
              <Select
                value={mortgage.loanType}
                htmlFor="loanType"
                className='loanType'
                placeholder='Select Loan Type'
                options={loanTypes}
                isSearchable={false}
                onChange={(value) => handleSelectChange(value, 'loanType')}
                styles={customSelectStyles('loanType')}
              />
            </div>
          </div>
          <div className='error-message-div'>
            <p id={`error-message-loanType`} className='error_message'>{errors.loanType}</p>
          </div>
          <div className='select_loan_amount'>
            <div className='name_div'>
              <h2>Required Loan Amount</h2>
            </div>
            <div className="data_div" style={{ position: 'relative' }}>
              <span className="currency_icon" style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)' }}>
                <MdCurrencyPound style={{ color: 'gray' }} />
              </span>
              <input
                className="loan-amount"
                placeholder="Enter Loan Amount"
                htmlFor="loanAmount"
                type='text'
                value={mortgage.loanAmount}
                onChange={handleInputChange}
                id="loanAmount"
                style={{ paddingLeft: '35px', borderColor: errors.loanAmount ? 'red' : '#ccc' }}
              />
            </div>
          </div>
          <div className='error-message-div'>
            <p id={`error-message-loanAmount`} className='error_message'>{errors.loanAmount}</p>
          </div>
          <div className='select_applicant'>
            <div className='name_div'>
              <h2>Number of Applicants</h2>
            </div>
            <div className='data_div'>
              <Select
                value={mortgage.applicantCount}
                className="applicant-count"
                htmlFor="applicantCount"
                placeholder="Select No. of Applicants"
                options={applicantArray}
                isSearchable={false}
                onChange={(value) => handleSelectChange(value, 'applicantCount')}
                styles={customSelectStyles('applicantCount')}
              />
            </div>
            <div className='error-message-div'>
              <p id={`error-message-applicantCount`} className='error_message'>{errors.applicantCount}</p>
            </div>
          </div>
          <div className="phone_number_div">
            {mortgage.applicantCount && (
              [...Array(parseInt(mortgage.applicantCount.value))].map((_, i) => (
                <PhoneNumberInput
                  key={`mobilePhone${i + 1}`}
                  label={`Mobile No for Applicant ${i + 1}:`}
                  htmlFor={`mobilePhone${i + 1}`}
                  placeholder="Enter mobile number"
                  value={mortgage[`mobilePhone${i + 1}`]}
                  onChange={(value) => handlePhoneNumber(value, `mobilePhone${i + 1}`)}
                  error={errors[`mobilePhone${i + 1}`]}
                />
              ))
            )}
          </div>
          <center><button type="button" className="proceed-btn" onClick={handleFormSubmission}> Proceed </button></center>
        </div>
      </main>
    </div>
  );
}

export default Home;